// import React, { useState } from "react";
// import {
//   Nav,
//   Form,
//   Card,
//   Container,
//   Image,
//   Dropdown,
//   Navbar,
// } from "react-bootstrap";
// import { Link, useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";

// //image
// import user1 from '../../../../assets/images/user/defultimg.png';
// import user2 from "../../../../assets/images/user/02.jpg";
// import user3 from "../../../../assets/images/user/03.jpg";
// import user4 from "../../../../assets/images/user/04.jpg";
// import user5 from "../../../../assets/images/user/01.jpg";
// import user13 from "../../../../assets/images/user/07.jpg";

// import shop1 from "../../../../assets/images/store/06.jpg";
// import shop2 from "../../../../assets/images/store/02.jpg";
// import shop3 from "../../../../assets/images/store/01.jpg";

// // Import selectors & action from setting store
// import * as SettingSelector from "../../../../store/setting/selectors";

// // Redux Selector / Action
// import { useDispatch, useSelector } from "react-redux";
// import SearchModal from "../../../search-modal";
// import { googlelogout } from "../../../../store/user/userThunk";
// import { resetProfile } from "../../../../store/user/userSlice";

// const Header = () => {
//   const appName = useSelector(SettingSelector.app_name);
//   let { profile } = useSelector((state) => state.userservice);
//   const [active, setActive] = useState("home");
//   const [showSignOutModal, setShowSignOutModal] = useState(false);
//   const navigate = useNavigate()
//   let dispatch = useDispatch();
//   const minisidebar = () => {
//     const sidebarMini = document.getElementsByTagName("ASIDE")[0];
//     if (sidebarMini.classList.contains("sidebar-mini")) {
//       sidebarMini.classList.remove("sidebar-mini");
//     } else {
//       sidebarMini.classList.add("sidebar-mini");
//     }
//   };

//   const handleSignOutClick = () => {
//     setShowSignOutModal(true);
//   };

//   // Function to handle cancel action
//   const handleCancelSignOut = () => {
//     setShowSignOutModal(false);
//   };

//   // Function to handle confirm action
//   const handleConfirmSignOut = () => {
//     // Perform logout logic here
//     logout(); // Your existing logout function
//     setShowSignOutModal(false);
//     navigate('/'); // Redirect to home or login page after sign out
//   };
//   const dropdownContent = document.querySelectorAll(".sub-drop");
//   if (dropdownContent) {
//     dropdownContent.forEach((element) => {
//       setTimeout(() => {
//         element.style = "";
//       }, 100);
//     });
//   }

//   let logout = async () => {
//     if (profile?.prowider == "google") {
//       await googlelogout();
//       dispatch(resetProfile());
//       //  dispatch(resetProfile())
//     }
//     // dispatch(resetProfile())

//     Cookies.remove("token");
//     Cookies.remove("twofatoken");
//     navigate("/")
//     dispatch(resetProfile());
//   };
//   return (
//     <>
//       <div className="iq-top-navbar border-bottom">
//         <Navbar
//           expand="lg"
//           variant="light"
//           className="nav navbar navbar-expand-lg navbar-light iq-navbar p-lg-0"
//         >
//           <Container fluid className="navbar-inner">
//             <div className="d-flex align-items-center pb-2 pb-lg-0 d-xl-none">
//               <Link
//                 to="/"
//                 className="d-flex align-items-center iq-header-logo navbar-brand d-block d-xl-none"
//               >
//                 <img src={require("../../../../assets/images/logo2.png")} className="max-w-[70px] max-h-[74px]" />
//               </Link>
//               <Link
//                 className="sidebar-toggle"
//                 data-toggle="sidebar"
//                 data-active="true"
//                 onClick={minisidebar}
//                 to="#"
//               >
//                 <div className="icon material-symbols-outlined iq-burger-menu">
//                   {" "}
//                   menu{" "}
//                 </div>
//               </Link>
//             </div>

//             <div className="d-flex align-items-center">
//               <div className="d-flex align-items-center justify-content-between product-offcanvas">
//                 <div
//                   className="offcanvas offcanvas-end shadow-none iq-product-menu-responsive d-none d-xl-block"
//                   tabIndex="-1"
//                   id="offcanvasBottomNav"
//                 >
//                   <div className="offcanvas-body">
//                     <ul className="iq-nav-menu list-unstyled">
//                       <li className="nav-item">
//                         <Link
//                           className={`nav-link menu-arrow justify-content-start ${active === "home" ? "active" : ""
//                             }`}
//                           to="/"
//                           onClick={() => setActive("home")}
//                         >
//                           <span className="nav-text">Home</span>
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//               <Dropdown
//                 bsPrefix=" "
//                 className="iq-search-bar device-search position-relative d-none d-lg-block"
//               >
//                 <Dropdown.Toggle
//                   as="form"
//                   bsPrefix=" "
//                   action="#"
//                   className="searchbox open-modal-search"
//                 >

//                 </Dropdown.Toggle>
//                 <SearchModal />
//               </Dropdown>
//             </div>

//             <ul className="navbar-nav navbar-list">

//               <Dropdown as="li" className="nav-item user-dropdown">
//                 <Dropdown.Toggle
//                   as="a"
//                   to="#"
//                   className="d-flex align-items-center"
//                   id="drop-down-arrow"
//                 >
//                   {/* <img  alt="Profile" className="img-fluid m- rounded-circle" /> */}
//                   <Image
//                     src={
//                       profile?.image
//                         ? profile?.image.includes("uploads")
//                           ? `${process.env.REACT_APP_BASE_URL}/${profile.image}`
//                           : profile.image
//                         : user1
//                     }
//                     className="img-fluid rounded-circle avatar-48 border border-2 me-3 object-cover"
//                     alt="user"
//                     loading="lazy"
//                   />
//                 </Dropdown.Toggle>
//                 <Dropdown.Menu className={`sub-drop caption-menu `}>
//                   <Card className="shadow-none m-0">
//                     <Card.Header>
//                       <div className="header-title">
//                         <h5 className="mb-0 ">Hello {profile?.fullName}</h5>
//                       </div>
//                     </Card.Header>
//                     <Card.Body className="p-0 ">
//                       <div className="d-flex align-items-center iq-sub-card border-0">
//                         <span className="material-symbols-outlined">
//                           line_style
//                         </span>
//                         <div className="ms-3">
//                           <Link
//                             to="/dashboards/app/profile"
//                             className="mb-0 h6"
//                           >
//                             My Profile
//                           </Link>
//                         </div>
//                       </div>
//                       <div className="d-flex align-items-center iq-sub-card border-0">
//                         <span className="material-symbols-outlined">
//                           manage_accounts
//                         </span>
//                         <div className="ms-3">
//                           <Link to="/Settings" className="mb-0 h6">
//                             Settings
//                           </Link>
//                         </div>
//                       </div>
//                       <div
//                         className="d-flex align-items-center iq-sub-card"
//                         onClick={handleSignOutClick} // Updated to show popup
//                       >
//                         <span className="material-symbols-outlined">login</span>
//                         <div className="ms-3">
//                           <Link to="#" className="mb-0 h6"> {/* Changed to # to prevent navigation */}
//                             Sign out
//                           </Link>
//                         </div>
//                       </div>

//                     </Card.Body>
//                   </Card>
//                 </Dropdown.Menu>
//               </Dropdown>
//             </ul>
//           </Container>
//         </Navbar>
//       </div>
//       {showSignOutModal && (
//         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full transform animate-in fade-in zoom-in duration-300">
//             <div className="p-6 sm:p-8 text-center">
//               <div className="w-16 h-16 mx-auto mb-6 bg-red-100 rounded-full flex items-center justify-center">
//                 <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth="2"
//                     d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 005.656 5.656l1.172-1.172M10.172 13.828a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656L13 7"
//                   />
//                 </svg>
//               </div>
//               <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3">Sign Out</h3>
//               <p className="text-gray-600 mb-8">Are you sure you want to sign out? This action cannot be undone.</p>

//               <div className="flex flex-col sm:flex-row gap-3">
//                 <button
//                   onClick={handleCancelSignOut}
//                   className="flex-1 px-6 py-3 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-2xl font-semibold transition-all duration-300 transform hover:scale-105"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleConfirmSignOut}
//                   className="flex-1 px-6 py-3 bg-red-500 to-red-600 text-white rounded-2xl font-semibold hover:bg-red-600 transition-all duration-300 transform hover:scale-105"
//                 >
//                   Sign Out
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Header;




import React, { useState } from "react";
import {
  Nav,
  Form,
  Card,
  Container,
  Image,
  Dropdown,
  Navbar,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { 
  FiMenu, 
  FiSearch, 
  FiUser, 
  FiSettings, 
  FiLogOut,
  FiHome,
  FiBell,
  FiMail
} from "react-icons/fi";

//image
import user1 from '../../../../assets/images/user/defultimg.png';
import user2 from "../../../../assets/images/user/02.jpg";
import user3 from "../../../../assets/images/user/03.jpg";
import user4 from "../../../../assets/images/user/04.jpg";
import user5 from "../../../../assets/images/user/01.jpg";
import user13 from "../../../../assets/images/user/07.jpg";

import shop1 from "../../../../assets/images/store/06.jpg";
import shop2 from "../../../../assets/images/store/02.jpg";
import shop3 from "../../../../assets/images/store/01.jpg";

// Import selectors & action from setting store
import * as SettingSelector from "../../../../store/setting/selectors";

// Redux Selector / Action
import { useDispatch, useSelector } from "react-redux";
import SearchModal from "../../../search-modal";
import { googlelogout } from "../../../../store/user/userThunk";
import { resetProfile } from "../../../../store/user/userSlice";

const Header = () => {
  const appName = useSelector(SettingSelector.app_name);
  let { profile } = useSelector((state) => state.userservice);
  const [active, setActive] = useState("home");
  const [showSignOutModal, setShowSignOutModal] = useState(false);
  const navigate = useNavigate()
  let dispatch = useDispatch();
  
  const minisidebar = () => {
    const sidebarMini = document.getElementsByTagName("ASIDE")[0];
    if (sidebarMini.classList.contains("sidebar-mini")) {
      sidebarMini.classList.remove("sidebar-mini");
    } else {
      sidebarMini.classList.add("sidebar-mini");
    }
  };

  const handleSignOutClick = () => {
    setShowSignOutModal(true);
  };

  // Function to handle cancel action
  const handleCancelSignOut = () => {
    setShowSignOutModal(false);
  };

  // Function to handle confirm action
  const handleConfirmSignOut = () => {
    // Perform logout logic here
    logout(); // Your existing logout function
    setShowSignOutModal(false);
    navigate('/'); // Redirect to home or login page after sign out
  };

  const dropdownContent = document.querySelectorAll(".sub-drop");
  if (dropdownContent) {
    dropdownContent.forEach((element) => {
      setTimeout(() => {
        element.style = "";
      }, 100);
    });
  }

  let logout = async () => {
    if (profile?.prowider == "google") {
      await googlelogout();
      dispatch(resetProfile());
      //  dispatch(resetProfile())
    }
    // dispatch(resetProfile())

    Cookies.remove("token");
    Cookies.remove("twofatoken");
    navigate("/")
    dispatch(resetProfile());
  };

  return (
    <>
      {/* Modern Header with Tailwind CSS */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-40">
  {/* <div className="max-w-7xl pl-4 pr-10 sm:pl-6 sm:pr-6 lg:pl-8 lg:pr-0"> */}

        <div className="max-w-8xl  pl-4 pr-10 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-[75px] lg:h-[75px]">
            
            {/* Left Section - Logo & Mobile Menu */}
           <div className="flex items-center space-x-4">
              <button
                onClick={minisidebar}
                className="xl:hidden p-2 rounded-lg text-gray-600 hover:text-[#50B5FF] hover:bg-[#50B5FF]/10 transition-all duration-300"
              >
                <FiMenu className="w-6 h-6" />
              </button>
              {/* <Link
                to="/"
                className="flex items-center space-x-3 group"
              >
                <div className="relative">
                  <img 
                    src={require("../../../../assets/images/logo2.png")} 
                    className="w-12 h-12 lg:w-14 lg:h-14 object-contain transition-transform duration-300 group-hover:scale-105" 
                    alt="Logo"
                  />
                  <div className="absolute -inset-1 bg-gradient-to-r from-[#50B5FF] to-blue-400 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                </div>
                <div className="hidden lg:block">
                  <h1 className="text-xl font-bold bg-gradient-to-r from-[#50B5FF] to-blue-600 bg-clip-text text-transparent">
                    {appName || "Dashboard"}
                  </h1>
                </div>
              </Link> */}
              <Link
                to="/"
                onClick={() => setActive("home")}
                className={`flex items-center space-x-2 px-4 py-2 rounded-xl font-medium transition-all duration-300 ${
                  active === "home"
                    ? "bg-[#50B5FF] text-white "
                    : "text-gray-600 hover:text-[#50B5FF] hover:bg-[#50B5FF]/10"
                }`}
              >
                <FiHome className="w-5 h-5" />
                <span>Home</span>
              </Link>
            </div>

            {/* Center Section - Navigation (Desktop) */}
            {/* <nav className="flex items-center space-x-4">
              <Link
                to="/"
                onClick={() => setActive("home")}
                className={`flex items-center space-x-2 px-4 py-2 rounded-xl font-medium transition-all duration-300 ${
                  active === "home"
                    ? "bg-[#50B5FF] text-white "
                    : "text-gray-600 hover:text-[#50B5FF] hover:bg-[#50B5FF]/10"
                }`}
              >
                <FiHome className="w-5 h-5" />
                <span>Home</span>
              </Link>
            </nav> */}

            {/* Right Section - Search & User Menu */}
            <div className="flex items-center space-x-4">
              
              {/* Search Button */}
              {/* <Dropdown
                bsPrefix=" "
                className="relative"
              >
                <Dropdown.Toggle
                  as="button"
                  bsPrefix=" "
                  className="hidden lg:flex items-center justify-center w-10 h-10 rounded-xl bg-gray-50 text-gray-600 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF] transition-all duration-300"
                >
                  <FiSearch className="w-5 h-5" />
                </Dropdown.Toggle>
                <SearchModal />
              </Dropdown> */}

              {/* Notification Bell */}
              {/* <button className="hidden lg:flex items-center justify-center w-10 h-10 rounded-xl bg-gray-50 text-gray-600 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF] transition-all duration-300 relative">
                <FiBell className="w-5 h-5" />
                <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"></span>
              </button> */}

              {/* Messages */}
              {/* <button className="hidden lg:flex items-center justify-center w-10 h-10 rounded-xl bg-gray-50 text-gray-600 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF] transition-all duration-300">
                <FiMail className="w-5 h-5" />
              </button> */}

              {/* User Dropdown */}
              <Dropdown as="div" className="relative">
                <Dropdown.Toggle
                  as="button"
                  className="flex items-center space-x-3 p-1 rounded-xl hover:bg-gray-50 transition-all duration-300 group"
                >
                  <div className="relative">
                    <Image
                      src={
                        profile?.image
                          ? profile?.image.includes("uploads")
                            ? `${process.env.REACT_APP_BASE_URL}/${profile.image}`
                            : profile.image
                          : user1
                      }
                      className="w-10 h-10 lg:w-12 lg:h-12 rounded-xl object-cover border-2 border-gray-200 group-hover:border-[#50B5FF] transition-all duration-300"
                      alt="user"
                      loading="lazy"
                    />
                    <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></div>
                  </div>
                  <div className="hidden lg:block text-left">
                    <p className="text-sm font-semibold text-gray-900 group-hover:text-[#50B5FF] transition-colors duration-300">
                      {profile?.fullName || "User"}
                    </p>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className="absolute right-0 mt-2 w-72 bg-white rounded-2xl shadow-2xl border border-gray-100 py-2 z-50">
                  {/* User Info Header */}
                  {/* <div className="px-6 py-4 border-b border-gray-100">
                    <div className="flex items-center space-x-4">
                      <Image
                        src={
                          profile?.image
                            ? profile?.image.includes("uploads")
                              ? `${process.env.REACT_APP_BASE_URL}/${profile.image}`
                              : profile.image
                            : user1
                        }
                        className="w-12 h-12 rounded-xl object-cover border-2 border-[#50B5FF]/20"
                        alt="user"
                        loading="lazy"
                      />
                      <div>
                        <h3 className="font-semibold text-gray-900 text-lg">
                          Hello, {profile?.fullName || "User"}!
                        </h3>
                        <p className="text-sm text-gray-500">Welcome back</p>
                      </div>
                    </div>
                  </div> */}

                  {/* Menu Items */}
                  <div className="py-2">
                    <Link
                      to="/dashboards/app/profile"
                      className="flex items-center space-x-3 px-6 py-3 text-gray-700 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF] transition-all duration-300 group"
                    >
                      <div className="p-2 rounded-lg bg-gray-100 group-hover:bg-[#50B5FF]/20 transition-all duration-300">
                        <FiUser className="w-4 h-4" />
                      </div>
                      <span className="font-medium">My Profile</span>
                    </Link>

                    <Link
                      to="/Settings"
                      className="flex items-center space-x-3 px-6 py-3 text-gray-700 hover:bg-[#50B5FF]/10 hover:text-[#50B5FF] transition-all duration-300 group"
                    >
                      <div className="p-2 rounded-lg bg-gray-100 group-hover:bg-[#50B5FF]/20 transition-all duration-300">
                        <FiSettings className="w-4 h-4" />
                      </div>
                      <span className="font-medium">Settings</span>
                    </Link>

                    <button
                      onClick={handleSignOutClick}
                      className="w-full flex items-center space-x-3 px-6 py-3 text-red-600 hover:bg-red-50 transition-all duration-300 group"
                    >
                      <div className="p-2 rounded-lg bg-red-100 group-hover:bg-red-200 transition-all duration-300">
                        <FiLogOut className="w-4 h-4" />
                      </div>
                      <span className="font-medium">Sign Out</span>
                    </button>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </header>

      {/* Enhanced Sign Out Modal */}
      {showSignOutModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50 animate-in fade-in duration-300">
          <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full transform animate-in fade-in zoom-in duration-300">
            <div className="p-8 text-center">
              {/* Icon */}
              <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-red-100 to-red-200 rounded-2xl flex items-center justify-center">
                <FiLogOut className="w-10 h-10 text-red-600" />
              </div>

              {/* Content */}
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Sign Out</h3>
              <p className="text-gray-600 mb-8 leading-relaxed">
                Are you sure you want to sign out? You'll need to sign in again to access your account.
              </p>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  onClick={handleCancelSignOut}
                  className="flex-1 px-8 py-4 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-2xl font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirmSignOut}
                  className="flex-1 px-8 py-4 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-2xl font-semibold hover:from-red-600 hover:to-red-700 transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
                >
                  Sign Out
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;